import { TEMPLATE_SPLIT } from './config';

export const timeFormat = (str: string) => {
  const [hour, minite] = str?.split(':') || [];
  if (!hour || !minite) {
    return '';
  }
  return `${hour}:${minite}`;
};

const weekMap = {
  1: '一',
  2: '二',
  3: '三',
  4: '四',
  5: '五',
  6: '六',
  7: '日',
};

export const weekFormat = (data: number | Array<number>) => {
  let value: Array<number> = Array.isArray(data) ? data : [data];
  const text = value.map((v: number) => `周${weekMap[v]}`);
  return Array.isArray(data) ? text : text[0];
};

export const renderArray = (arr: Array<any>, options: { className?: string } = {}) => {
  const { className = '' } = options;
  return arr.length ? <div className={className}>{
    arr.map((v: string, i: number) => <div key={i}>{v}</div>)
  }</div> : '-';
};

/**
 * 解析模板配置
 * 模板格式：{{[type]|[index]?|[group]=[defaultValue]}}
 *  type: 类型，可选值period-周期、field-指标、operator-计算符号、values-值（数组）
 *  index: 序号，当前表达式在规则中的序号，规则只有一个表达式时可省略
 *  group: 所属分组，用于将可选值分组以便于筛选切换
 *  defaultValue: 默认值，不指定时默认分组第一个值
 * 例：
 *  {{period|30}}：周期，近30天
 *  {{field|0|conversions_count}}，第一个表达的指标，可选指标为“目标转化量”所在分组
 *  {{operator|1|compare=GE}}，第二哥表达式的计算符号，可选符号为“compare”所在分组，默认GE
 *  {{values|0|number=4}}，第一个表达式的值，数字类型，默认4
 * @param match 模板内容
 * @returns
 */
export const getTemplateValue = (match: string) => {
  const arr = match.split(TEMPLATE_SPLIT);
  let type; let index; let group; let defaultValue;
  switch (arr.length) {
    case 2:
      index = 0;
      ([type, group] = arr);
      break;
    case 3:
      ([type, index, group] = arr);
      break;
  }
  if (group) {
    ([group, defaultValue] = group.split('='));
  }
  return {
    type,
    index,
    group,
    defaultValue,
  };
};
